export default {"src":"/planos/_next/static/media/equifax-bill.097e7dd8.svg","height":40,"width":48,"blurWidth":0,"blurHeight":0};